import cricketIcon from '../assets/images/sportsbook/icons/cricket.png';
import soccerIcon from '../assets/images/sportsbook/icons/soccer.png';
import tennisIcon from '../assets/images/sportsbook/icons/tennis.png';
import HorseRacingIcon from '../assets/images/sportsbook/icons/horseracing.png';

export const SPORTS_ICONS = {
  Soccer: soccerIcon,
  Football: soccerIcon,
  Tennis: tennisIcon,
  Cricket: cricketIcon,
  HorseRacing: HorseRacingIcon,
};
